/* eslint-disable @typescript-eslint/no-empty-function */
import { TextField, InputAdornment, IconButton, InputLabel } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export const InputField = (props) => {
  const { question, placeholder, label, type, value, onChange, required, sx,minRows,handleEnterKeyPress,disabled } = props; // Added sx prop
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  useEffect(()=>{

  },[value])
  const handleInputChange = (event) => {
    const inputValue = event.target.value;

    if (type === 'email') {
      if (!/^\S+@\S+\.\S+$/.test(inputValue)) {
        setError('Invalid email address.');
      } else {
        setError(null);
        onChange(event);
      }
    } else if (type === 'password') {
      if (inputValue.length < 8) {
        setError('Password must be at least 8 characters long.');
      } else {
        setError(null);
        onChange(event);
      }
    } else if (type === 'number') {
      if (!/^\d+$/.test(inputValue)) {
        setError('Please enter a valid number.');
      } else {
        setError(null);
        onChange(event);
      }
    } else {
      if (required && inputValue.length < 0) {
        setError('This field is required.');
      } else {
        setError(null);
        onChange(event);
      }
    }
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div style={{display:'flex',flexDirection:'column'}}>
      <div style={{ margin: '5px', color:disabled? '#808080': '#131F32', fontSize: '14px', fontWeight: '600', lineHeight: '24px',marginBottom:'10px',textTransform:'capitalize' }}>
        
        {question} {required && <span style={{ color: 'red' }}>*</span>}
      </div>

      <TextField
        size='small'
       
        variant='outlined'
        // label={label}
        // InputLabelProps={{
        //   style: {
        //     whiteSpace: 'initial', // Prevent wrapping until the end of the container
        //     textAlign:'justify'
        //     // color: '#ccc',
        //     // fontSize: '12px',
        //   },
        // }}
        // label={label}
        placeholder={label}
        type={showPassword ? 'text' : type || 'text'}
        value={value}
        // defaultValue={value}
      
        disabled={disabled||false}
        onKeyDown={handleEnterKeyPress}
        minRows={minRows >= 3 ? minRows-1 : 1} 
        maxRows={minRows+1||1}
        multiline={minRows >= 3} 
        onChange={handleInputChange}
        error={Boolean(error)}
        helperText={error}
        InputProps={{
          style: {
            whiteSpace: 'break-spaces',

          },
          endAdornment: (
            type === 'password' && (
              <InputAdornment position="end">
                <IconButton onClick={handleTogglePasswordVisibility} edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            )
          ),
        }}
        sx={{
          ...sx, // Spread the sx prop to override any existing styles
          width: '100%',
          // height:'40px',
          // height: `${minRows * 24}px`,
          marginBottom:'10px',
          // marginTop: '5px',
          '& label.Mui-focused': {
            color: '#333',
          },
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#808080',
          },
          whiteSpace: 'break-spaces',
          borderRadius: '20px',
          '& .MuiInputBase-input::placeholder': {
            fontSize: '14px',
            whiteSpace: 'break-spaces',
          },
        }}
      />
    </div>
  );
};

export default InputField;
